import * as React from "react";
import { forwardRef, Ref } from "react";
import { styled } from "@mui/material";
import { GenderValue } from "shared";
import {
  OptionsWrapper,
  QuestionOptionsContainer,
} from "./layout/questionOptionsContainer";
import { AnswerButton, SelectionType } from "../uiControllers/AnswerButton";
import clsx from "clsx";

//region [[ Styles ]]
const Options = styled(OptionsWrapper)({});
//endregion [[ Styles ]]

//region [[ Props ]]

export interface ClosedSingleQuestionViewProps {
  className?: string;
  canSkip?: boolean;
  gender: GenderValue;
  onClick: (SelectionType) => void;
  children?: React.ReactNode;
  darkBg?: boolean;
}

//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]

/* This is only the dumb view of the closed single question
 *  ******* DO NOT ADD ANY BUSINESS LOGIC HERE! THIS IS VIEW ONLY COMPONENT *****/
export const ClosedSingleQuestionView = forwardRef(
  (props: ClosedSingleQuestionViewProps, ref: Ref<HTMLDivElement>) => {
    return (
      <QuestionOptionsContainer
        className={clsx(
          props.className,
          "closed-single-question-view",
          props.canSkip ? "three-way" : "two-way",
        )}
        darkbg={props.darkBg ? "true" : "false"}
        ref={ref}
      >
        {props.children}
        <Options>
          <AnswerButton
            type={SelectionType.YES}
            onClick={() => props.onClick(SelectionType.YES)}
            gender={props.gender}
          />
          <AnswerButton
            gender={props.gender}
            type={SelectionType.NO}
            onClick={() => props.onClick(SelectionType.NO)}
          />
          {props.canSkip && (
            <AnswerButton
              gender={props.gender}
              type={SelectionType.DONT_KNOW}
              onClick={() => props.onClick(SelectionType.DONT_KNOW)}
            />
          )}
        </Options>
      </QuestionOptionsContainer>
    );
  },
);
